import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function SaladsPage() {

    const heroData = [
        {
          title: "Salads",
          content: "Our salads are a blend of fresh, crisp ingredients and vibrant flavors. Whether you prefer classic Caesar or something more adventurous, our salads are wholesome and satisfying.",
          image: images.SaladsHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Baby Spinach Salad ",
        content: "Baby spinach with strawberries, feta cheese, and Asian dressing",
        price: 0,
        image: [
          images.Salad1,
        ]
      },
      {
        name: "Caesar Salad",
        content: "Romaine lettuce and grilled chicken in Caesar dressing, topped with croutons",
        price: 0,
        image: [
          images.Salad2,
        ]
      },
      {
        name: "Burrata Salad",
        content: "Cherry tomatoes, basil, rocket leaves, olive oil, and balsamic dressing",
        price: 0,
        image: [
          images.Salad3,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Caesar Salad",
        image1: [
          images.Salad2,
        ],
        content1: "Romaine lettuce and grilled chicken in Caesar dressing, topped with croutons",
        name2: "Burrata Salad",
        image2: [
          images.Salad3,
        ],
        content2: "Cherry tomatoes, basil, rocket leaves, olive oil, and balsamic dressing"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
